import * as bootstrap from 'bootstrap';
import Swiper from 'swiper/bundle';
import Helper from './helper';
import 'swiper/css/bundle';

import.meta.glob([
    '../img/**'
]);

class App {
    constructor() {
        this.init();
    }

    init() {
        this.initFileInputs();
        this.asyncForms();
        this.map();
        this.cookies();
        this.referenceCarousel();
    }

    initFileInputs() {
        document.querySelectorAll('.form-upload input[type="file"]').forEach(input => {
            input.addEventListener('change', function() {
                let fileNameElement = this.closest('.form-upload').querySelector('.file-name');

                // Toggle visibility
                fileNameElement.style.display = 'inline';

                // Set file names as a comma-separated list
                fileNameElement.innerText = Array.from(this.files).map(file => file.name).join(', ');
            });
        });
    }

    /**
     * Process asynchronous forms
     */
    asyncForms() {
        let gRecaptchaWidgets = [];

        document.querySelectorAll('.g-recaptcha-widget').forEach(recaptcha => {
            let widgetId = grecaptcha.render(recaptcha.id, {
                'sitekey' : config.recaptcha_site_key
            });

            gRecaptchaWidgets.push(widgetId);
        });

        /**
         * Refresh reCAPTCHA
         */
        let refreshRecaptcha = () => {
            // Check if reCAPTCHA is loaded
            if (typeof grecaptcha === 'undefined') {
                return;
            }

            // Refresh all recaptcha widget instances
            gRecaptchaWidgets.forEach(widgetId => {
                grecaptcha.reset(widgetId);
            });
        }

        setInterval(function() {
            refreshRecaptcha();
        }, 2 * 60 * 1000);

        document.querySelectorAll('.form-async').forEach(form => {
            form.addEventListener('submit', (e) => {
                e.preventDefault();

                // Serialize all form data
                let formData = new FormData(form);

                // Fetch container for the form messages
                let formMessages = form.querySelector('.form-messages');

                // Clear the form errors
                form.querySelectorAll('[data-error]').forEach(errorMessage => {
                    // Clear error message
                    errorMessage.innerHTML = '';

                    // Remove multiple status class
                    errorMessage.classList.remove('multiple');
                });

                // Clear the form messages
                formMessages.replaceChildren();

                Helper.post(form.getAttribute('action'), formData).then(response => {
                    if (response.redirect_url) {
                        // Redirect to the given URL
                        window.location.href = response.redirect_url;
                    }
                    else {
                        // Reset form
                        form.reset();

                        // Refresh reCAPTCHA
                        refreshRecaptcha();

                        formMessages.innerHTML = '<div class="alert alert-basic alert-' + response.message.type + '"><span>' + response.message.text + '</span></div>';
                    }
                })
                .catch(error => {
                    let statusCode = error.statusCode;

                    switch (statusCode) {
                        case 422:
                            // Set error messages
                            Object.entries(error.response.errors).forEach(([key, errors]) => {
                                // Find the target element with data-error attribute
                                const targetElement = form.querySelector('[data-error="' + key + '"]');

                                if (targetElement === null) {
                                    return;
                                }

                                if (errors.length > 1) {
                                    // Mark container as multiple errors
                                    targetElement.classList.add('multiple');
                                }

                                errors.forEach(function (error) {
                                    // Create a new <span> element
                                    const errorSpan = document.createElement('span');

                                    // Set the text content of the <span>
                                    errorSpan.textContent = error;

                                    // Append the <span> as a child of the target element
                                    targetElement.appendChild(errorSpan);
                                });
                            });
                            break;

                        default:
                            // Show notification
                            alert('Er is iets misgegaan.');
                    }

                    // Refresh reCAPTCHA
                    refreshRecaptcha();

                    // Reject the promise
                    return Promise.reject(error.statusText);
                });
            });
        });
    }

    map () {
        let container = document.getElementById('map');

        if (container === null) {
            return;
        }

        let osm = L.tileLayer('https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png', {
            minZoom: 4,
            maxZoom: 20
        });

        let map = new L.Map('map', {
            center: new L.LatLng(52.20593294544564, 6.889811955812788),
            scrollWheelZoom: false,
            zoom: 15
        });

        let icon = L.icon({
            iconUrl: container.dataset.urlMarker,
            iconSize: [95, 114],
        })

        L.marker([52.20593294544564, 6.889811955812788])
            .setIcon(icon)
            .addTo(map)
            .bindPopup('Anzers<br />Zuiderval 67-2 (Park Phi)<br/>7543 EZ Enschede');

        let controls_layer = L.control.layers({
            osm: osm.addTo(map),
            google: L.tileLayer('http://www.google.cn/maps/vt?lyrs=s@189&gl=cn&x={x}&y={y}&z={z}', {
                attribution: 'google'
            })
        }).addTo(map);

        map.removeControl(controls_layer);
    }

    /**
     * Set cookie preferences
     */
    cookies() {
        let form = document.getElementById('form-cookies');

        if (form === null) {
            return false;
        }

        // Show the cookie form
        form.classList.remove('fade');

        // Add cookie selection state
        document.body.classList.add('cookie-selection');

        let options = form.querySelector('.cookie-options');

        let textChecked   = 'Alle cookies accepteren';
        let textUnchecked = 'Geselecteerde cookies accepteren'

        let buttonSubmit = form.querySelector('button[type="submit"]');

        let isAllCookiesChecked = function () {
            let checked = true;

            options.querySelectorAll('.form-check-input').forEach(switchElement => {
                if (switchElement.checked === false) {
                    checked = false;
                }
            });

            return checked;
        }

        options.querySelectorAll('.form-check-input').forEach(input => {
            // Bind the change event listener to the form check input
            input.addEventListener('change', function () {
                buttonSubmit.innerText = isAllCookiesChecked() ? textChecked : textUnchecked;
            });

            // Manually create on on-change event
            let event = new Event('change');

            // Manually dispatch event
            input.dispatchEvent(event);
        });

        const collapseCookies = document.getElementById('collapse-cookies');

        collapseCookies.addEventListener('show.bs.collapse', () => {
            collapseCookies.querySelectorAll('.form-check-input:not(#cookies-functional)').forEach(input => {
                input.checked = false;
            });

            buttonSubmit.innerText = textUnchecked;
        })

        form.addEventListener('submit', function(e) {
            e.preventDefault();

            let formData = new FormData(this);

            if (e.submitter) {
                // Manually add button name and value
                formData.append(e.submitter.name, e.submitter.value);
            }

            Helper.post(this.action, formData).then(() => {
                // Remove cookie selection state
                document.body.classList.remove('cookie-selection');

                // Fade out the form
                form.classList.add('fade');

                setTimeout(function () {
                    // Reload page
                    location.reload();
                }, 1000);
            })
                .catch(error => {
                    // Reject the promise
                    return Promise.reject(error.statusText);
                });
        });
    }

    referenceCarousel() {
        document.querySelectorAll('.reference-carousel').forEach(element => {
            new Swiper('#' + element.getAttribute('id'), {
                breakpoints: {
                    0: {
                        slidesPerView: 2,
                        spaceBetween: 50
                    },
                    576: {
                        slidesPerView: 3,
                        spaceBetween: 50
                    },
                    992: {
                        slidesPerView: 4,
                        spaceBetween: 50
                    },
                    1200: {
                        slidesPerView: 5,
                        spaceBetween: 50
                    },
                    1600: {
                        slidesPerView: 6,
                        spaceBetween: 100
                    }
                },
                autoplay: {
                    delay: 2000
                },
                slidesPerGroup: 1,
                loop: true
            });
        });
    }
}

window.addEventListener('load', () => new App());
